import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {Button, Modal, Result, List, Alert, Space} from "antd";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import ws_socket from "@tools/web_socket";
import GlobalContext from "@components/contexts/GlobalContext";

const MailingResultInfo: React.FC = () => {
    const [mailingInfo, setMailingInfo] = useState(null);
    const [settingsSuccess, setSettingsSuccess] = useState(false);
    const [settingsError, setSettingsError] = useState(null);
    const {t} = useTranslation()
    const {dispatch} = useContext(GlobalContext);

    const resCallback = useRef(ws_socket.on("mailing", ws_event => {
        if(ws_event?.data?.template_name &&  ws_event?.data?.outputData) {
            dispatch({type : "remove_socket_events", value: [ws_event.data.id]})
            setMailingInfo(ws_event?.data?.outputData);
        }
    }));

    const errorSettingsCallback = useRef(ws_socket.on("mailingSettingsError", ws_event => {
        setSettingsError(ws_event?.data?.error);
    }));

    const successSettingsCallback = useRef(ws_socket.on("mailingSettingsSuccess", ws_event => {
        setSettingsSuccess(true);
    }));

    const socketEmitter = useMemo(() => {
        return resCallback.current
    }, [])

    useEffect(() => {
        return () => {
            socketEmitter.off();
            errorSettingsCallback.current.off()
            successSettingsCallback.current.off()
        }
    }, [socketEmitter, errorSettingsCallback, successSettingsCallback])


    const showModal = useMemo(() => {
        return !!mailingInfo || settingsSuccess || !!settingsError
    }, [mailingInfo, settingsSuccess, settingsError])

    const reset = useCallback(() => {
        setMailingInfo(null)
        setSettingsSuccess(false)
        setSettingsError(null)
    }, [])

   return <Modal
        onCancel={() => reset}
        closable={false}
        visible={showModal}
        width={800}
        footer={false}
    >
       {mailingInfo && <Result
           status={mailingInfo?.error?.length > 0 ? "error" : "success"}
           title={mailingInfo?.error?.length > 0 ? t("mailing.error.title") : t("mailing.success.title")}
           subTitle={mailingInfo?.error?.length > 0 ? t("mailing.error.sub_title") : t("mailing.success.title")}
           extra={[
               <Button key="close" type="primary" onClick={reset}>
                   {t("button.close")}
               </Button>
           ]}
       >
           {mailingInfo?.sent?.length > 0 && <List
               size="small"
               itemLayout="horizontal"
               dataSource={mailingInfo?.sent}
               renderItem={(item: any) => (
                   <List.Item>
                       <List.Item.Meta
                           avatar={<CheckOutlined  style={{color: "green"}}/>}
                           title={item.email}
                       />
                   </List.Item>
               )}
           />}
           {mailingInfo?.error?.length > 0 && <List
               size="small"
               itemLayout="horizontal"
               dataSource={mailingInfo?.error}
               renderItem={(item: any) => (
                   <List.Item>
                       <List.Item.Meta
                           avatar={<CloseOutlined style={{color: "red"}}/>}
                           title={item.email}
                           description={item.message}
                       />
                   </List.Item>
               )}
           />}
       </Result>}
       {settingsSuccess && <Result
           status="success"
           title={t("mailing.settings.success")}
           extra={[
               <Button key="close" type="primary" onClick={reset}>
                   {t("button.close")}
               </Button>
           ]}
       />}
       {settingsError && <Result
           status="error"
           title={t("mailing.settings.error")}
           extra={<Space direction={"vertical"}>
                   <Alert type="error" message={settingsError} />
                   <Button key="close" type="primary" onClick={reset}>
                       {t("button.close")}
                   </Button>
           </Space>}
       />}
    </Modal>
};

export default MailingResultInfo;
